const accessToAll = [
  'Chief',
  'Admin',
  'PackingTrackerChief',
  'PackingTrackerOperator',
  'PackingTrackerLeader',
  'QualityControl',
];

const viewers = ['PackingTrackerViewer', 'Viewer'];
export const packingTracerAccionesRoles = {
  sharedActions: {
    info: [...accessToAll, ...viewers],
    dataDisplay: [...accessToAll, ...viewers],
    clone: [...accessToAll, ...viewers],
    rebuild: [...accessToAll, ...viewers],
    pallet: [...accessToAll],
    truck: [...accessToAll],
    destroyPallet: [...accessToAll],
    legacyInventory: [...accessToAll, ...viewers],
  },

  sideNavActions: {
    scanner: [...accessToAll, ...viewers],
  },
};
